import { jsx as o } from "react/jsx-runtime";
import { c as l } from "../clsx-OuTLNxxd.js";
const r = "Spinner-module_spinner__gWmhT",
  s = "Spinner-module_color-white__8lIaf",
  m = "Spinner-module_color-titanium__lDHFL",
  t = "Spinner-module_color-neutral__--Imm",
  a = "Spinner-module_size-small__H-nEI",
  u = "Spinner-module_size-medium__UJW9K",
  c = "Spinner-module_size-large__lwOsp",
  e = {
    spinner: r,
    colorWhite: s,
    colorTitanium: m,
    colorNeutral: t,
    sizeSmall: a,
    sizeMedium: u,
    sizeLarge: c
  },
  d = _ref => {
    let {
      color: i,
      size: n
    } = _ref;
    return /* @__PURE__ */o("div", {
      className: l(e.spinner, {
        [e.sizeSmall]: n == "small",
        [e.sizeMedium]: n == "medium",
        [e.sizeLarge]: n == "large",
        [e.colorNeutral]: i == "neutral10",
        [e.colorWhite]: i == "white",
        [e.colorTitanium]: i == "titanium"
      })
    });
  };
export { d as Spinner };